import React from 'react';

import { useParams } from 'react-router';

import { CategoriaComunicadoFormComp } from './components/pages/CategoriaForm';
import { CategoriaComunicadoListComp } from './components/pages/CategoriaList';

import { FormProvider } from 'context/FormContext';
import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';

export function CategoriaComunicadoList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();
    if (!hasPermission(['COMUNICADO_CATEGORIA_GERENCIAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <CategoriaComunicadoListComp />
        </ListagemProvider>
    );
}

export function CategoriaComunicadoForm() {
    const { hasFormPermission, alertNotPermission } = usePermissionsContext();
    const { id } = useParams();

    if (!hasFormPermission('COMUNICADO_CATEGORIA_GERENCIAR', id)) return alertNotPermission();

    return (
        <FormProvider>
            <CategoriaComunicadoFormComp />
        </FormProvider>
    );
}
